import { SegmentProps } from './props';
import { Segment } from './Segment';

const FilledSegment = (props: SegmentProps) => (
  <Segment {...props} fillColor="grey05" />
);

export { FilledSegment };
